import React, { useState, useEffect } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

import { Loading, Grid } from "@nextui-org/react";

import { Bar } from 'react-chartjs-2';
import Service from "src/api/Service";
import colorPalette from "src/assets/js/colorPalette";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const getUniquePeriods = (data) => {
  const periods = data.map((item) => item.period);
  return Array.from(new Set(periods));
};
const formatDataForChart = (props,data) => {
  const periods = Array.from(new Set(data.map((item) => item.period)));
  const products = Array.from(new Set(data.map((item) => item.products)));

  const datasets = products.map((product, index) => {
    const productData = data.filter((item) => item.products === product);
    const volumes = periods.map((period) => {
      const periodData = productData.find((item) => item.period === period);
      return periodData ? periodData.vol : 0;
    });


    return {
      label: product,
      data: volumes,
      backgroundColor: "#"+colorPalette[0]['KPIDashboard'][props.palette][index],
      
    };
  });

  return {
    labels: periods,
    datasets: datasets,
  };
};


export default function GroupHBar(props) {

  const [showLegends, setShowLegends] = useState(false);
  const [dataS, setdataS] = useState([]);
  const [Message, setMessage] = useState([]);
  const [labelS, setlabelS] = useState([]);
  const [isLoading, setisLoading] = useState(true);
  const [countFilter, setCountFilter] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [TempData,setTempData] = useState([])
  function getData(){

    console.log(props.prams.keyname)
    var obj={}
    obj['data']={SProd: "level_2", SLoc: "level_3", loc: ["TH"], prod: ["Reese", "Kisses", "Nugget", "Hershey"], slec: "15"};
    obj['keyname']=props.prams.keyname;
     Service.post("dashboard/kpis",obj,(status,data)=>{    
      if(status==200){
        console.log(data)
        setdataS(data['data']);
        setMessage(data['message']);
        setisLoading(false)
      }
    });   
  }

  useEffect(() => {
    getData();
  },[]);

  function filterSummary(filterData){
   
    var obj ={};
    obj['data']=filterData;
    obj['keyname']=props.prams.keyname;
     Service.post("dashboard/kpis",obj,(status,data)=>{               
     
       if(status==200){
          setdataS(data['data']);
          setMessage(data['message'])
          setisLoading(false);     
       
       }
   });
  }
  if(props.filterData.length == undefined  && countFilter != props.countFilter){
    setisLoading(true)
    setCountFilter(props.countFilter);
    setShowLegends(false);
    filterSummary(props.filterData);
  }


  const data = dataS;
const chartData = formatDataForChart(props,data);

const options = {
  indexAxis: 'y',
    responsive: true,
    // interaction: {
    //   mode: 'index',
    //   intersect: false,
    // },
    scales: {
      x: {
        beginAtZero: true,
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: context => {
            const datasetLabel = context.dataset.label || '';
            const productLabel = chartData.labels[context.dataIndex];
            const volume = context.formattedValue;
            return `${datasetLabel} (${volume})`;
            // return `${datasetLabel}: ${productLabel} - ${volume}`;
          },
        },
      },
      legend: {
        display:showLegends,
        position: 'bottom',   
        align:'left',
        labels: {
          boxWidth:10,
          borderWidth:0,
          textAlign:'left',
          font: {
            size: 10
          },
          // generateLabels: function (chart) {
          //   const labels = chart.data.datasets.map(dataset => {
          //     const product = dataset.product;
          //     const channels = dataset.channels.join(', ');
          //     return {
          //       text: `${product}`,
          //       fillStyle: dataset.backgroundColor,
          //       strokeStyle: dataset.borderColor,
          //       lineWidth: dataset.borderWidth,
          //       hidden: dataset.hidden,
          //       index: dataset.index,
          //       lineWidth: 0, 
          //     };
          //   });
          //   return labels;
          // },
        },
      },
    },
 
};

function Legend(){
 
  setShowLegends(!showLegends);
  console.log(showLegends);
}
if(isLoading){
  return( 
     <Grid.Container gap={2}>
    <Grid>
      <Loading  color="secondary" type="points-opacity" />
    </Grid>
  </Grid.Container>);
}

console.log(props);
console.log(props.prams);
if(dataS.length==0){
  return ( <>
    <div className='row'>
                <div className='col-lg-5'>
                  <div className='componentNameC'>{props.prams.component}</div>
                </div>
  
                <div className='col-lg-5'>
                </div>  
  
                <div className='col-lg-2'>

            </div>
    </div>
  
    <div className="p-2">
  
      <div className="row">
  
  
      <div className='col-lg-12'  style={{height: '328px',display: 'grid',placeItems:'center'}}>          
        <center style={{color:'#566573', fontWeight:'500'}}> {Message}</center>
      </div>
  
  </div>
  </div>
  
  </>);
}
return ( <>
  <div className='row'>
              <div className='col-lg-5'>
                <div className='componentNameC'>{props.prams.component}</div>
              </div>

              <div className='col-lg-5'>
              </div>  

              <div className='col-lg-2'>
              <div className="form-check component_legend" >
              <span className="bigcheck">
                  <label className="bigcheck">
                      <input type="checkbox" className="bigcheck" onChange={Legend}  name="Legend" value="yes"/>
                      <span className="bigcheck-target"></span>
                      &nbsp; Legend
                  </label>
              </span>
            </div>
          </div>
  </div>

  <div className="p-2">

    <div className="row">
     <div className='col-lg-12'>          
      <Bar data={chartData} options={options} />
    </div>
</div>
</div>

</>);
};
